import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import gemmaAllBrands from '../../images/logos/GEMMAplussubbrands.jpg'

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'background.paper',
        py: 6,
        marginTop: '1%',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="sm">
        <img src={gemmaAllBrands} alt="Logo" style={{ width: '60%', marginBottom: '10px' }} />
        <Typography variant="body2" color="textSecondary">
          &copy; {new Date().getFullYear()} GEMMA. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
